import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, width }) => css`
    width: ${width === 'half' ? '50%' : '100%'};

    @media (max-width: ${theme.v2.breakpoints.sm}){
      width: 100%;
    }
  `}
`;

export const Card = styled.div`
  ${({ theme, height }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    height: ${height === 'fit' ? 'fit-content' : '100%'};
    justify-content: space-between;
    padding: 24px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}){
      border-radius: 16px;
    }
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.title};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}){
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
`;

export const LinkItem = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 4px;

    a {
      color: ${theme.v2.colors.brand.primaryMedium};
      font-size: 14px;
      font-weight: ${theme.v2.font.weights.regular};
      text-decoration: none;
      transition: text-decoration 150ms ease-in-out;

      &:hover {
        text-decoration: underline;
      }
    }
  `}
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
`;

export const ButtonsContainer = styled.div`
  ${({ theme, $isHalfWidth }) => css`
    display: flex;
    flex-direction: ${$isHalfWidth ? 'row' : 'column'};
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.lg}){
      flex-direction: column;
      gap: 12px;
    }
  `}
`;
